import script from "./PopupNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupNotice.vue?vue&type=script&lang=ts&setup=true"

import "./PopupNotice.vue?vue&type=style&index=0&id=3a7fb440&lang=scss"

const __exports__ = script;

export default __exports__